export default __webpack_public_path__ + "static/media/DotTurquoise.e804012b.svg";